import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import AddPrcielist from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface AddPrcieState extends ListState<AddPrcielist> {
    editSeckilllist: AddPrcielist;
}
class AddPrcieModule extends ListModule<AddPrcieState, any, AddPrcielist> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<AddPrcielist>(),
        loading: false,
        editTemplate: new AddPrcielist(),
        addPriceVersion: 0,
        addPriceProductInfo: [],
        addPriceActInfo: [],
    };
    public actions = {
        async getAll(context: ActionContext<AddPrcieState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/BuyLimit/GetBuyLimitList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<AddPrcielist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    public mutations = {
        setState(state, payload) {
            for (let key in payload) {
                state[key] = payload[key]
            }
        },
        setCurrentPage(state: AddPrcieState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: AddPrcieState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: AddPrcieState, AddPrcielist: AddPrcielist) {
            state.editSeckilllist = AddPrcielist;
        },
    };
}
const addPrcieModule = new AddPrcieModule();
export default addPrcieModule;
